import React, { useEffect, useState } from "react";
import { useNavigate, useParams } from "react-router-dom";
import DepartmentsInventoryTable from "./Components/DepartmentsInventoryTable";
import AddDepartmentsInventory from "./Components/AddDepartmentsInventory";
import { hasAddAccess } from "../../../../../Common/CheckAccess";

const DepartmentsInventory = () => {
  const [selectedDepartment, setSelectedDepartment] = useState();
  const paramData = useParams();
  const [permissions, setPermissions] = useState([]);
  const navigate = useNavigate();

  const existingPermissions = localStorage.getItem("checkPermission");

  useEffect(() => {
    if (existingPermissions != undefined) {
      const parsedData = JSON.parse(existingPermissions);
      setPermissions(parsedData);
    }
  }, [existingPermissions]);

  return (
    <>
      <div className="px-xl-5 px-lg-4 px-3 py-3 page-body">
        <div className="row g-3">
          <div className="col-sm-12">
            <div className="d-flex align-items-center justify-content-between flex-wrap">
              <h3 className="fw-bold mb-0">Inventory List</h3>
              <div className="col-auto d-flex w-sm-100 align-content-center gap-3">
              <button
                type="button"
                className="btn btn-secondary"
                style={{ maxHeight: "40px" }}
                onClick={() => {
                  navigate(-1);
                }}
              >
                Back
              </button>
                {hasAddAccess(permissions, "inventory") && (<button
                  type="button"
                  className="btn btn-dark"
                  data-bs-toggle="offcanvas"
                  data-bs-target="#add-department-inventory"
                  aria-controls="add-department-inventory"
                  onClick={() => setSelectedDepartment(null)}
                >
                  Add Invetory Items
                </button>)}
              </div>
            </div>
          </div>
          <div className="col-sm-12 ">
            <div className="card">
              <div className="card-body ">
                <DepartmentsInventoryTable
                  setSelectedDepartment={setSelectedDepartment}
                  subCategoryId={paramData?.subCategoryId}
                />
              </div>
            </div>
          </div>
        </div>
      </div>
      <AddDepartmentsInventory
        subCategoryId={paramData?.subCategoryId}
        department_id={paramData?.categoryId}
        setSelectedDepartment={setSelectedDepartment}
        selectedDepartment={selectedDepartment}
      />
    </>
  );
};

export default DepartmentsInventory;
